import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, usePermissions, useUser } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect, useState } from "react"
import UserDetailView from './UserDetailView'

const UserEdit = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    const [userId, setUserId] = useState(id)
    let { email, setEmail, name, setName } = useUser(id)
    const [dummyPassword, setDummyPassword] = useState("")
    const { permissions: userPermissions, setPermissions: setUserPermissions } = usePermissions(id)
    const { permissions } = usePermissions(getId())

    useEffect(() => {
        setUserId(id)
    }, [id])

    useEffect(() => {
        if(permissions.user !== undefined && !permissions.user) {
            toast.error("You don't have permission to edit users!")
            navigate("/")
        }
    }, [permissions])

    return <UserDetailView id={userId} setId={setUserId}
        name={name} setName={setName}
        email={email} setEmail={setEmail}
        password={dummyPassword} setPassword={setDummyPassword}
        userPermissions={userPermissions} setUserPermissions={setUserPermissions}
    />
}

export default UserEdit